import { PRIVAT_ADMIN_INITIAL_ROUTE, PRIVAT_INITIAL_ROUTE } from '@/routes/consts'

export const getPrivateInitialRoute = ({ isAdmin }: { isAdmin?: boolean }) => {
  return isAdmin ? PRIVAT_ADMIN_INITIAL_ROUTE : PRIVAT_INITIAL_ROUTE
}
